import React from 'react';

import { useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router';

import { FullscreenLoader } from '@hrlogics/react-components';

import { appRoutes } from '@clearverify/constants';

import { useAppAuth } from 'src/hooks/auth';
import { useFilterStorage } from 'src/hooks/common';
import { useModalsContext } from 'src/hooks/shared';

export const LogoutPage: React.FC = () => {
  const navigate = useNavigate();

  const apolloClient = useApolloClient();

  const { logout } = useAppAuth();
  const { resetStorage: resetFilterStorage } = useFilterStorage();
  const { resetState: resetModalsState } = useModalsContext();

  React.useEffect(() => {
    const logoutAction = async () => {
      resetFilterStorage();
      resetModalsState();
      await apolloClient.clearStore();
      await logout(appRoutes.auth.index);
      navigate(appRoutes.auth.index);
    };

    logoutAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <FullscreenLoader />;
};
